import React, { useCallback } from "react";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import { AppUtils } from "../../models/common/appUtils";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../framework/customStore";
import { setSidebarData } from "../../store/workShiftPlanningSlice";
import IconButton from "@mui/material/IconButton";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

interface WorkShiftChipsProps {
    plannedShiftId: string;
    actualShiftsDuration: number;
    plannedDuration: number;
}

export const WorkShiftChips = ({
    plannedShiftId,
    actualShiftsDuration,
    plannedDuration,
}: WorkShiftChipsProps) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const openSidebar = useCallback(() => {
        dispatch(
            setSidebarData({
                plannedShiftId,
            })
        );
    }, [dispatch, plannedShiftId]);

    return (
        <>
            <Tooltip title={t("workShiftPlanning.tooltips.actualWorkTime")}>
                <Chip
                    color="success"
                    size="small"
                    onClick={openSidebar}
                    label={
                        actualShiftsDuration
                            ? AppUtils.getDurationStrByDurationMinShort(
                                actualShiftsDuration
                            )
                            : "-"
                    }
                />
            </Tooltip>
            <Tooltip title={t("workShiftPlanning.tooltips.plannedWorkTime")}>
                <Chip
                    color="primary"
                    size="small"
                    onClick={openSidebar}
                    label={
                        plannedDuration
                            ? AppUtils.getDurationStrByDurationMinShort(
                                plannedDuration
                            )
                            : "-"
                    }
                />
            </Tooltip>
            {actualShiftsDuration ? (
                <IconButton onClick={openSidebar} size="small">
                    <VisibilityOutlinedIcon fontSize="small" />
                </IconButton>
            ) : null}
        </>
    );
};
